var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.2 5.87c-.07 0-.14 0-.2.01V2.01c.07-.01.13-.01.2-.01 2.26 0 4.2.69 5.79 1.86.5.36.54 1.09.1 1.52L16.7 6.74c-.34.33-.86.39-1.25.12-.75-.52-1.82-.99-3.25-.99M21.8 12.22c0 3.05-1.09 5.61-2.98 7.36C17.17 21.11 14.9 22 12.2 22c-.07 0-.13 0-.2-.01v-3.87c.07.01.13.01.2.01 1.49 0 2.62-.41 3.47-1 1.33-.93 1.93-2.32 2.04-3.24H13.2c-.55 0-1-.45-1-1v-1.71c0-.55.45-1 1-1h7.55c.51 0 .94.38.99.89.04.35.06.72.06 1.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 10.02c-.2.62-.32 1.29-.32 1.98s.12 1.35.33 1.98c.78 2.35 2.94 4.06 5.49 4.14v3.87a9.96 9.96 0 0 1-8.72-5.5h-.01C2.59 15.13 2.2 13.61 2.2 12s.39-3.13 1.07-4.49A9.96 9.96 0 0 1 12 2.01v3.87c-2.36.07-4.37 1.53-5.29 3.6q-.12.27-.21.54",
    opacity: 0.4
  })));
};
export default SvgGoogle;